import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import OrderEditor from "@/pages/OrderEditor";
import DeveloperPortal from "@/pages/DeveloperPortal";
import Calendar from "@/pages/Calendar";
import History from "@/pages/History";
import ManageTeam from "@/pages/ManageTeam";
import { ChatAssistant } from "@/components/ChatAssistant";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

// Pages that belong only to the Merchandiser / Senior / Owner portals (not Developer).
function PortalRoute({ children }) {
  const { user } = useAuth();
  if (user && user.role === "developer") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/orders/:id" element={<ProtectedRoute><OrderEditor /></ProtectedRoute>} />
          <Route path="/calendar" element={<ProtectedRoute><PortalRoute><Calendar /></PortalRoute></ProtectedRoute>} />
          <Route path="/history" element={<ProtectedRoute><PortalRoute><History /></PortalRoute></ProtectedRoute>} />
          <Route path="/team" element={<ProtectedRoute><PortalRoute><ManageTeam /></PortalRoute></ProtectedRoute>} />
          <Route path="/developer" element={<ProtectedRoute><DeveloperPortal /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <ChatAssistant />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
